<ng-container *ngIf="vo$ | async; let vo">
	<app-page>
		<app-page-header></app-page-header>

		<app-page-actions>
			<button
				matTooltip="new"
				id="{{ cmpId }}-new-btn"
				i18n-matTooltip="@@general.action.new"
				mat-icon-button
				color="primary"
				(click)="createNewSemanticRule()">
				<mat-icon [svgIcon]="DcIcons.AddElement"></mat-icon>
			</button>
		</app-page-actions>

		<app-page-content>
			<app-panel
				headerHeight="3rem"
				isAlwaysOpen="true"
				hasSearchableGrid="true"
				hasRefresh="true"
				maxActionsCount="6"
				[actionsAvailable]="toggleActions"
				[itemsCount]="vo.list.elements.size"
				[actions]="panelActions"
				(refresh)="refresh()"
				(search)="search($event)">
				<span panel-info>
					<div *ngIf="selectionCount">
						<span>{{ selectionCount }} &#32;</span>
						<span i18n="@@expositions.columns.config.selectedElements">
							Elements selectionnée
						</span>
					</div>
				</span>
				<span panel-title i18n="@@semantic-rule.list.title">
					semantic rules
				</span>
				<dx-data-grid
					keyExpr="id"
					[elementAttr]="{
						id: 'semantic-rule-list',
						class: 'app-semantic-rule-list'
					}"
					[dataSource]="vo.list.elements | toArray"
					[hoverStateEnabled]="true"
					[showColumnHeaders]="true"
					[allowColumnResizing]="false"
					[columnAutoWidth]="false"
					[showRowLines]="false"
					[showColumnLines]="false"
					[rowAlternationEnabled]="false"
					[showBorders]="false"
					[width]="'100%'"
					[noDataText]="''"
					(onCellHoverChanged)="onCellHover($event)"
					(onSelectionChanged)="onSelectionChange($event)"
					(onContentReady)="onGridContentReady()">
					<dxo-selection
						mode="multiple"
						showCheckBoxesMode="always"></dxo-selection>

					<dxo-header-filter [visible]="true"></dxo-header-filter>

					<dxo-load-panel
						shadingColor="rgba(0,0,0,0)"
						[indicatorSrc]="DcLoaders.LoaderInfinite"
						[height]="100"
						[width]="100"
						[enabled]="vo.isFirstLoad"
						[showIndicator]="true"
						[showPane]="true"
						[shading]="true"></dxo-load-panel>

					<!-- Fixable in position columns	-->
					<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

					<ng-container *ngFor="let col of vo.list.availableColumns | toArray">
						<dxi-column
							*ngIf="col.field === 'description'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[visible]="col.visible"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[format]="col.format"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"></dxi-column>
						<dxi-column
							*ngIf="col.field === 'label'"
							[dataField]="col.field"
							[caption]="col.alias"
							[groupIndex]="col.groupIdx"
							[fixed]="false"
							[allowResizing]="true"
							[allowHiding]="true"
							[allowGrouping]="true"
							[visible]="col.visible"
							[allowSearch]="col.isSearchable"
							[allowFiltering]="col.isFilterable"
							[allowSorting]="true"
							[format]="col.format"
							[alignment]="'left'"
							[visibleIndex]="col.visibleIndex"
							[allowHeaderFiltering]="col.hasHeaderFilter"
							[minWidth]="100"
							[width]="'25%'"></dxi-column>
					</ng-container>

					<dxi-column
						[fixed]="false"
						[allowResizing]="false"
						[allowHiding]="false"
						[allowGrouping]="false"
						[allowSearch]="false"
						[allowSorting]="false"
						[alignment]="'left'"
						[visibleIndex]="12"
						[showInColumnChooser]="false"
						cellTemplate="actionsTemplate"></dxi-column>

					<div
						class="actions-column-template"
						*dxTemplate="let cell of 'actionsTemplate'">
						<div [hidden]="cell.rowIndex !== currentlyHovered">
							<button
								id="{{ cmpId }}-{{ cell.rowIndex }}-duplicate-btn"
								mat-icon-button
								class="actions-column-template__btn"
								matTooltip="duplicate-semantic-rule"
								i18n-matTooltip="@@semantic-rule.list.action.duplicate"
								(click)="duplicateSemanticRule(cell.data)">
								<mat-icon [svgIcon]="ActionIcons.DuplicateElement"></mat-icon>
							</button>
							<button
								id="{{ cmpId }}-{{ cell.rowIndex }}-delete-btn"
								mat-icon-button
								class="actions-column-template__btn"
								matTooltip="delete-semantic-rule"
								i18n-matTooltip="@@semantic-rule.list.action.delete"
								(click)="deleteSemanticRule(cell.data)">
								<mat-icon [svgIcon]="ActionIcons.Delete"></mat-icon>
							</button>
						</div>
					</div>

					<dxo-group-panel [visible]="true"></dxo-group-panel>

					<!-- Filterable columns	-->
					<dxo-filter-row
						[visible]="vo.list.elements.size !== 0"></dxo-filter-row>

					<!-- Sorting	-->
					<dxo-sorting mode="multiple"></dxo-sorting>

					<!-- Pagination -->
					<dxo-paging [pageSize]="pageSize"></dxo-paging>
					<dxo-pager
						[visible]="true"
						[showPageSizeSelector]="true"
						[allowedPageSizes]="allowPageSizes"></dxo-pager>

					<dxo-column-chooser
						[allowSearch]="true"
						[enabled]="false"
						[mode]="'select'">
						<dxo-selection
							[allowSelectAll]="true"
							[recursive]="false"></dxo-selection>
					</dxo-column-chooser>

					<!-- State persistence	-->
					<dxo-state-storing
						type="localStorage"
						[savingTimeout]="0"
						[enabled]="true"
						[storageKey]="dxLocalStorageKey"></dxo-state-storing>
				</dx-data-grid>
			</app-panel>
			<ng-container
				*ngIf="!vo.isLoading && vo.list.elements.size === 0"
				[ngTemplateOutlet]="noData"></ng-container>
		</app-page-content>
	</app-page>
</ng-container>
<ng-template #noData>
	<div class="no-data-template">
		<mat-icon
			[svgIcon]="DcIcons.SpellCheck"></mat-icon>
		<app-button
			class="small"
			id="{{ cmpId }}-add-new"
			[leftIcon]="DcIcons.AddCircle"
			i18n="@@semantic-rule.list.action.new"
			(click)="createNewSemanticRule()">
			new-semantic-rule
		</app-button>
	</div>
</ng-template>
